<template>
  <base-draggable-modal
      :name="modal_name"
      max-height="80vh"
      width="50vw"
      :fullscreen="$vuetify.display.xsOnly"
      :ref="modal_name">
    <v-card rounded="xl">
      <base-modal>
        <template #header>
          <v-toolbar class="draggable_selector" flat color="secondary" density="compact">
            <v-toolbar-title class="text-primary">{{ $store.getters.translate('create') }} {{ $store.getters.translate(page.model) }}</v-toolbar-title>
          </v-toolbar>
        </template>
        <template #content>
            <v-card-text>
              <template v-for="field in usual_fields">
                <template v-if="field.name === 'description' || ((page.model === 'protectionkind' || page.model === 'equipmenttype' || page.model === 'distributiondevicefunction') && field.name === 'name')">
                  <v-text-field
                      density="default"
                      class="reg-normal text-primary mt-3"
                      base-color="border-tertiary"
                      bg-color="secondary"
                      color="primary"
                      v-model="english_name"
                      hide-details
                      flat
                      clearable>
                    <template #label>
                      <span class="sm-normal text-subtle">{{ $store.getters.translate('en_name_desc') }}<strong>*</strong></span>
                    </template>
                  </v-text-field>
                  <v-text-field
                      density="default"
                      class="reg-normal text-primary mt-3"
                      base-color="border-tertiary"
                      bg-color="secondary"
                      color="primary"
                      v-model="dutch_name"
                      hide-details
                      flat
                      clearable>
                    <template #label>
                      <span class="sm-normal text-subtle">{{ $store.getters.translate('nl_name_desc') }}<strong>*</strong></span>
                    </template>
                  </v-text-field>
                </template>
                  <!--USUAL FIELDS-->
                <base-field
                    v-else
                    :key="field.name"
                    :modelValue="record[field.name]"
                    :field="field"
                    @change="usualFieldDataChanged"/>
              </template>
            </v-card-text>
        </template>
        <template #footer>
          <v-card-text>
            <v-row>
              <v-col>
                <base-action-button :width="'100%'" @action="reset">
                  <template #prepend><PhX style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("cancel") }}
                </base-action-button>
              </v-col>
              <v-col>
                <base-action-button :background="true" :width="'100%'" @action="save">
                  <template #prepend><PhFloppyDisk style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("save") }}
                </base-action-button>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
      </base-modal>
    </v-card>
  </base-draggable-modal>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions";
import BaseModal from "../../components/commonComponents/BaseModal";
import BaseDraggableModal from "../../components/commonComponents/BaseDraggableModal";
import BaseActionButton from "./BaseActionButton";
import {PhFloppyDisk, PhX} from "@phosphor-icons/vue";

export default {
  props: ["modal_name", "page"],
  components: {
    BaseModal,
    BaseDraggableModal,
    BaseActionButton,
    PhFloppyDisk, PhX,
  },
  data() {
    return {
      record: {},
      usual_fields: [],
      english_name: null,
      dutch_name: null,
    };
  },
  methods: {
    ...helpFunctions.modal_functions,
    async load() {
      this.record = {};
      this.openModal(this.modal_name);
      await this.getFields();
    },
    async save() {
      let key = '';
      if (this.english_name) {
        key = this.$lodash.lowerCase(this.english_name);
      }
      else if (this.dutch_name) {
        key = this.$lodash.lowerCase(this.dutch_name);
      }

      if(key === '') {
        if (this.page.model === 'protectionkind' || this.page.model === 'equipmenttype' || this.page.model === 'distributiondevicefunction') {
          this.$toast.error(this.$store.getters.translate("required_field") + ": " + this.$store.getters.translate('name'));
        }
        else {
          this.$toast.error(this.$store.getters.translate("required_field") + ": " + this.$store.getters.translate('description'));
        }
      }
      else {
        let new_key = key.replaceAll('(', "_").replaceAll(')', "_").replaceAll('[', "_").replaceAll(']', "_")
            .replaceAll('-', "_").replaceAll('/', "_").replaceAll('\\', "_").replace(/ /g, "_");

        if (this.page.model === 'protectionkind' || this.page.model === 'equipmenttype' || this.page.model === 'distributiondevicefunction') {
          this.record.name = new_key;
        }
        else {
          this.record.description = new_key;
        }

        if (helpFunctions.modelFieldsFilled(this.$toast, this.record, this.usual_fields)) {
          let record_id = await helpFunctions.createModel(this.$toast, this.page.name, this.record);
          if(record_id) {
            if(this.english_name) {
              await helpFunctions.createModel(this.$toast, helpFunctions.pages.translations.name, { key: new_key, language: 'en', value: this.english_name });
            }
            if(this.dutch_name) {
              await helpFunctions.createModel(this.$toast, helpFunctions.pages.translations.name, { key: new_key, language: 'nl', value: this.dutch_name });
            }
            await this.$store.dispatch("refreshTranslations");
            this.$emit('refresh', record_id);
            this.reset();
          }
        }
      }
    },
    reset() {
      this.record = {};
      this.english_name = null;
      this.dutch_name = null;
      this.closeModal(this.modal_name);
    },
    usualFieldDataChanged(data) {
      if(this.record[data[0]] !== data[1]) {
        this.record[data[0]] = data[1];
      }
    },
    async getFields() {
      const response = await helpFunctions.getFields(this.page.model, "show_on_creation");
      this.usual_fields = response.usual_fields;
    },
  },
};
</script>